import {
  SetActiveSortColumnFunction,
  SetOccupationParamsFunction,
  UserOccupationFormatData,
  UserOccupationItem,
} from './user-occupation.types';

const capitalizeString = (str = '') => str.charAt(0).toUpperCase() + str.slice(1);

export const formatData = (docs: UserOccupationFormatData[]) =>
  docs
    ? docs.map((obj: UserOccupationFormatData) => {
        const id = obj._id;
        const { username, fullName, email, avatar } = obj.local;
        const { institutionName, institutionType, phoneNumber } = obj.demographics ?? '';
        const { jobTitle, occupation, companyId, team } = obj.business ?? '';

        return {
          id,
          username,
          fullName,
          email,
          avatar,
          jobTitle,
          occupation: capitalizeString(occupation),
          companyId,
          team: capitalizeString(team),
          phoneNumber,
          institutionName,
          institutionType: capitalizeString(institutionType),
        };
      })
    : [];

export const sortData = (
  setActiveSortColumn: SetActiveSortColumnFunction,
  setOccupationParams: SetOccupationParamsFunction,
  columnKey: keyof UserOccupationItem,
) => {
  setActiveSortColumn(columnKey);
  setOccupationParams((prevParams) => ({
    ...prevParams,
    sortOrderText: prevParams.sortOrderText === 'descending' ? 'ascending' : 'descending',
    sortColumn: columnKey.toString(),
  }));
};
